import $ from "./jquery";

function initUnitList(estl, $el) {
  if (estl) {
    customFilter(estl);
    if ($el.hasClass("estatetool-units--flb-custom")) {
      customUnits(estl);
    }
    if ($el.hasClass("estatetool-units--flb-custom2")) {
      customFilter2(estl);
    }

    // reset custom select
    if (estl.$form) {
      estl.$form.on("reset", function () {
        $(".estatetool-units .js-estl-select-dropdown").trigger("change");
      });
    }
  }
}

window.addEventListener("DOMContentLoaded", function () {
  $(".js-estl-units").each(function () {
    const estl = $(this).data("estatetool");
    if (estl) {
      initUnitList(estl, $(this));
    } else {
      // -- move properties field to toolbar
      $(this).on("estl:units:lazyLoaded", function (e, estl) {
        const field = estl.$side.find(".js-flb-estl-ejendomme-field");
        $(this).find(".js-flb-estl-toolbar-fields").append(field);
        initSwiper();
      });

      // wait for estl to be initialized
      $(this).on("estl:units:init", function (e, data) {
        initUnitList(data, $(this));
      });
    }
  });

  $("#js_estl_unit_loader").each(function () {
    const $form = $(this);

    if ($form.length === 0) {
      return;
    }

    $form.on("estl:unit:loaded", function () {
      initSwiper();
    });
  });
});

// handle custom filter
function customFilter(estl) {
  const $filterButton = $(".js-estl-filter-open");
  const $submitButton = $(".js-estl-filter-submit");

  // add custom filter parameter by floor
  estl.subscribe("afterFilter", function (ev) {
    const formData = estl.getFormData();

    estl.filteredItems = estl.filteredItems.filter((unit) => {
      return additionalFilters(formData, unit);
    });

    const length = estl.filteredItems.length ?? 0;

    setTimeout(() => {
      $submitButton.children("span").text(length);
    }, 1000);
  });

  estl.subscribe("input_change", function (ev) {
    updateUnitCount();
  });

  $filterButton.on("click", function (ev) {
    ev.preventDefault();
    setTimeout(() => {
      updateUnitCount();
    }, 100);
  });

  // update unit number on submit button
  function updateUnitCount() {
    const formData = estl.getFormData();

    let units = estl.getFilterUnits(formData);

    units = units.filter((unit) => {
      return additionalFilters(formData, unit);
    });

    const length = units?.length ?? 0;

    $submitButton.children("span").text(length);
  }
}

function customFilter2(estl) {
  const $resetButton = $(".js-flbestl-units-reset");

  estl.subscribe("enableReset", function (e, enable) {
    $resetButton.attr("disabled", !enable);
  });
}

function additionalFilters(formData, unit) {
  let valid = true;

  // floor
  let minFloors = parseInt(formData?.floor_min);
  let maxFloors = parseInt(formData?.floor_max);
  if (!isNaN(minFloors)) {
    valid = valid && parseInt(unit.floor) >= minFloors;
  }
  if (!isNaN(maxFloors) && maxFloors > 0) {
    valid = valid && parseInt(unit.floor) <= maxFloors;
  }

  // oriented
  if (formData.oriented) {
    const wc = formData.oriented;
    const filterWC = !Array.isArray(wc) ? wc.split(",") : wc;
    valid = valid && filterWC.includes(unit.parking_2);
  }

  // regions
  // if (formData.regions) {
  //   const reg = formData.regions;
  //   const filterReg = !Array.isArray(reg) ? reg.split(",") : reg;
  //   valid = valid && filterReg.includes(unit.parking_2);
  // }

  return valid;
}

// customize floor range input.
$(function () {
  const $range = $(".js-flb-estl-floor-range");
  if (!$range.length) {
    return;
  }

  const $slider = $(".estatetool-range__slider", $range);

  const $inputMin = $("input.estatetool-range__min", $range);
  const $inputMax = $("input.estatetool-range__max", $range);

  function setLabelMin(val) {
    let minLabel = 0 == val ? "St." : val + ". sal";
    $range.find(".js-estl-min-label").html(minLabel);
  }

  function setLabelMax(val) {
    let maxLabel = 0 == val ? "St." : val + ". sal";
    $range.find(".js-estl-max-label").html(maxLabel);
  }

  setLabelMin($inputMin.val());
  setLabelMax($inputMax.val());

  $slider.on("slide", function (ev, ui) {
    setLabelMin(ui.values[0]);
    setLabelMax(ui.values[1]);
  });
});

// --

function customUnits(estl) {
  let perPage = 6;
  let page = 0;
  let otherItems = [];

  let renderedItems = [];

  const $title = $(".flb-estl-units-others-title");
  const primaryId =
    $(".flb-estl-units-others-title")
      .closest(".estatetool-units")
      .data("primary-eid") ?? 7;
  const $gridWrapper = $(".flb-estatetool-grid");

  // to array
  const primaryIdArr = primaryId.split(",");

  estl.subscribe("afterFilter", function () {
    // split and filter primary property and other items
    const primaryItems = [];
    otherItems = [];

    estl.filteredItems.forEach((item) => {
      if (
        item.propertyId &&
        primaryIdArr.includes(item.propertyId.toString())
      ) {
        primaryItems.push(item);
      } else {
        otherItems.push(item);
      }
    });

    estl.filteredItems = primaryItems;

    render();

    // toggle class
    if (primaryItems.length) {
      $gridWrapper
        .closest(".estatetool-units")
        .addClass("flb-estl-units-has-primary");
    } else {
      $gridWrapper
        .closest(".estatetool-units")
        .removeClass("flb-estl-units-has-primary");
    }

    setEmptyMessage(primaryIdArr, primaryItems, otherItems);
  });

  function render() {
    if (estl.filteredItems.length && otherItems.length) {
      $title.show();
    } else {
      $title.hide();
    }

    if (!otherItems.length) {
      $gridWrapper.html("");
    }

    // reset and render
    page = 0;

    renderMore();
  }

  function renderMore() {
    page++;

    renderedItems = [];
    otherItems.slice(0, perPage * page).forEach((item) => {
      const $grid = estl.$gridItems.filter(`[data-id="${item.id}"]`);
      $grid
        .find(".estatetool-unit-card")
        .addClass("estatetool-unit-card--others");
      $grid.show();
      renderedItems.push($grid);
    });

    $gridWrapper.html(renderedItems);

    // load more button.
    if (renderedItems.length < otherItems.length) {
      $(".js-flb-estl-units-more-button").show();
    } else {
      $(".js-flb-estl-units-more-button").hide();
    }
  }

  function setEmptyMessage(primaryIds, primaryItems, otherItems) {
    const $result = estl.$result;
    const formData = estl.getFormData();
    let e_id = formData.e_id;

    // set message if no primary items
    if (primaryItems.length) {
      return;
    }

    let msg =
      "Vi har desværre ingen boliger, der matcher dine ønsker. Ved at ændre dine søgekriterier kan du få vist ledige boliger.";

    if (primaryItems.length || otherItems.length) {
      if (e_id) {
        if (!Array.isArray(e_id)) {
          e_id = e_id.split(",");
        }

        if (!primaryIds.includes(e_id)) {
          msg = "Bemærk at de valgte ejendomme ikke er en del af Fælledby.";
        }
      } else {
        if (!primaryItems.length && otherItems.length) {
          msg =
            "Vi har desværre ingen boliger i Fælledby, der matcher dine ønsker. Ved at ændre dine søgekriterier kan du få vist ledige boliger. Nedenfor vises boliger fra andre PensionDanmark ejendomme, som matcher dine ønsker.";
        }
      }
    }

    if (!$result) {
      return;
    }

    $result.closest(".js-estl-units").find(".js-estl-units-noresult").text(msg);
  }

  $(".js-flb-estl-units-more-button").on("click", function (ev) {
    ev.preventDefault();
    renderMore();
  });
}

function initSwiper() {
  if (
    globalEstatetool !== undefined &&
    globalEstatetool.swiper !== undefined &&
    globalEstatetool.swiperNavigation !== undefined
  ) {
    new globalEstatetool.swiper(".js-estatetool-swiper-images", {
      modules: [globalEstatetool.swiperNavigation],
      loop: false,

      // If we need pagination
      pagination: {
        el: ".estatetool-swiper-images__pagination",
        clickable: true,
      },

      // Navigation arrows
      navigation: {
        nextEl: ".estatetool-swiper-images__next",
        prevEl: ".estatetool-swiper-images__prev",
      },
    });
  }
}
